import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IssueForm from '../../components/Issues/IssueForm';
import issueService from '../../services/issueService';

const IssueEdit = () => {
  const { id } = useParams();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadIssue();
  }, [id]);

  const loadIssue = async () => {
    try {
      setLoading(true);
      const data = await issueService.getById(id);
      setIssue(data);
    } catch (error) {
      console.error('Error loading issue:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-center h-64">
          <div className="text-xl text-gray-600">Loading issue...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Edit Issue</h1>
      {issue && <IssueForm issue={issue} />}
    </div>
  );
};

export default IssueEdit;


